'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiInputChecked = function TiInputChecked(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 31.7h-13.4c-2.7 0-5-2.3-5-5v-13.4c0-2.7 2.3-5 5-5h8.4c0.9 0 1.6 0.8 1.6 1.7s-0.7 1.7-1.6 1.7h-8.4c-0.9 0-1.6 0.7-1.6 1.6v13.4c0 0.9 0.7 1.6 1.6 1.6h13.4c0.9 0 1.6-0.7 1.6-1.6v-5c0-1 0.8-1.7 1.7-1.7s1.7 0.7 1.7 1.7v5c0 2.7-2.3 5-5 5z m-4.8-7c-0.5 0-1.1-0.2-1.5-0.6l-4.5-4.5c-0.8-0.8-0.8-2.2 0-3.1 0.9-0.9 2.3-0.9 3.2 0l2.3 2.3 5.8-9c0.6-1.1 2-1.5 3-0.9 1.1 0.6 1.5 1.9 0.9 3l-7.2 11.7c-0.3 0.6-1 1-1.6 1.1-0.1 0-0.2 0-0.4 0z' })
        )
    );
};

exports.default = TiInputChecked;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/input-checked.js
// module id = 2092
// module chunks = 0